import { omit } from 'lodash'

export function countNotificationsNumber (notifications) {
  const notificationsCounters = omit(notifications, ['collectorInvoicesIds', 'errors'])

  return Object.keys(notificationsCounters).map(key => notificationsCounters[key])
    .reduce((sum, currentValue) => sum + currentValue)
}
